import React from 'react';
import { Radio } from '@mui/material';

import Box from '@mui/material/Box';

import { colors } from 'theme/colors';

import {
  Cell,
  ImpactText,
  LikelihoodText,
  MatrixContainer,
  getColor,
  getLabel,
  impacts,
  likelihoods,
  scores,
} from './styles';

interface RiskMatrixTableProps {
  selected: { impact: number; likelihood: number; risk: number };
  onChange: (newSelectedCell: { impact: number; likelihood: number; risk: number }) => void;
}

/* Render the impact labels row */
const RiskAssessmentTableFooter = (): React.ReactElement => (
  <>
    <Box sx={{ display: 'flex' }}>
      <Cell style={{ borderRight: 'none' }} />
      <Cell />
      {impacts.map((impact, i) => (
        <Cell key={i} style={{ borderBottom: `1px solid ${colors.grey[400]}` }}>
          {impact}
        </Cell>
      ))}
    </Box>
    <Box sx={{ display: 'flex' }}>
      <Cell style={{ borderRight: 'none' }} />
      <Cell />
      {[...Array(5)].map((_, colIndex) => (
        <Cell key={colIndex}>{colIndex + 1}</Cell>
      ))}
    </Box>
  </>
);

const RiskMatrixTable = ({ selected, onChange }: RiskMatrixTableProps): React.ReactElement => (
  <Box sx={{ padding: 20 }}>
    <h1 style={{ textAlign: 'center' }}>Select impact and likelihood</h1>
    <Box sx={{ display: 'flex' }}>
      <LikelihoodText>Likelihood</LikelihoodText>
      <MatrixContainer>
        {/* Render the main matrix grid with scores and radio buttons */}
        {scores.map((row, rowIndex) => (
          <div key={rowIndex} style={{ display: 'flex', borderBottom: `1px solid ${colors.grey[400]}` }}>
            {/* Render the likelihood labels row */}
            <Cell>{likelihoods[rowIndex]}</Cell>
            <Cell>{5 - rowIndex}</Cell>
            {/* render options */}
            {row.map((score, colIndex) => (
              <Cell key={colIndex} colors={getColor(5 - rowIndex, colIndex + 1)}>
                <Radio
                  size="small"
                  sx={{ padding: '2px' }}
                  checked={selected.impact === 5 - rowIndex && selected.likelihood === colIndex + 1}
                  onChange={() =>
                    onChange({
                      impact: 5 - rowIndex,
                      likelihood: colIndex + 1,
                      risk: (5 - rowIndex) * (colIndex + 1),
                    })
                  }
                />
                <p style={{ margin: 0 }}>
                  {score} - {getLabel(5 - rowIndex, colIndex + 1)}
                </p>
              </Cell>
            ))}
          </div>
        ))}

        <RiskAssessmentTableFooter />
      </MatrixContainer>
    </Box>

    <ImpactText>Impact</ImpactText>
  </Box>
);

export default RiskMatrixTable;
